/**
 * Money as TrafficPulse writes it, in the reporting currency (reporting-currency.ts). Born of
 * the 27/10 CZ stop-loss halt on "Profit €-10803.61": the drops' tracker report had come back
 * in Czech koruna (≈ $444) while the rule and the words said euros (28/10/2026).
 * For Media Devoted | Created By Ciro Autiero
 */
import { DEFAULT_REPORTING_CURRENCY } from './reporting-currency';

/** stats_json.currency on a saved drop: the currency its money was read in (absent = before 28/10/2026). */
export const STORED_BAG_CURRENCY_KEY = 'currency' as const;

const formats = new Map<string, Intl.NumberFormat>();

function formatWith(currency: string, decimals: number): Intl.NumberFormat {
  const key = `${currency}:${decimals}`;
  const hit = formats.get(key);
  if (hit) return hit;
  const f = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  formats.set(key, f);
  return f;
}

/**
 * "$18", "$20.11", "-$10,803.61", "$0.036" (decimals = 3): whole amounts without cents, the
 * minus before the symbol.
 */
export function formatMoney(
  value: number,
  decimals = 2,
  currency: string = DEFAULT_REPORTING_CURRENCY,
): string {
  // `|| 0`: a rounded -0 reads "$0", never "-$0".
  const rounded = Math.round(value * 10 ** decimals) / 10 ** decimals || 0;
  return formatWith(currency, Number.isInteger(rounded) ? 0 : decimals).format(rounded);
}
